import { IGridFlavor } from "../../../interfaces/igrid-flavor.interface";
import { RegularGridFlavor } from "./regular-grid-flavor";

// Currently ContactsGridFlavor is same as RegularGridFlavor so just extend it and we're done
export class ContactsGridFlavor extends RegularGridFlavor implements IGridFlavor {
    
}
